import { render, staticRenderFns } from "./OrderLayout.vue?vue&type=template&id=f2901558&scoped=true"
import script from "./OrderLayout.vue?vue&type=script&lang=js"
export * from "./OrderLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2901558",
  null
  
)

export default component.exports